import { IPrescription } from '@alberta/konexi-shared';
import { IPrescriptionPosition } from '@alberta/konexi-shared/dist/prescription/prescription-position';

export class PrescriptionViewModel implements IPrescription {
  medicalAidPrescription: boolean;
  tubeFeedingNutrition: boolean;
  prescriptionHeaderText: string;
  outboundDate: string;
  middleTexts: string[];
  positions: IPrescriptionPosition[];
  constructor() {}

}
